export const STEPS = {
  FORM: 'form',
  OPTIONS: 'options',
  PREVIEW: 'test',
  AUTOMATION: 'automation'
};
export const NAVIGATION_STEPS = [STEPS.FORM, STEPS.OPTIONS, STEPS.PREVIEW, STEPS.AUTOMATION];
export const VARIANT_GROUP_STEPS = {
  formFieldGroups: STEPS.FORM,
  themeName: STEPS.PREVIEW
};
export const STEP_LABELS_KEY = {
  [STEPS.FORM]: 'editor.navigation.steps.form',
  [STEPS.OPTIONS]: 'editor.navigation.steps.options',
  [STEPS.PREVIEW]: 'editor.navigation.steps.styleAndPreview',
  [STEPS.AUTOMATION]: 'editor.navigation.steps.automation'
};